<template>
  <div>
    <template v-if="isMobile"><start-screen-mobile /></template>
    <template v-else><start-screen-desktop /></template>
  </div>
</template>

<script>
import StartScreenDesktop from './StartScreenDesktop.vue';
import StartScreenMobile from './StartScreenMobile.vue';

export default {
  components: { StartScreenDesktop, StartScreenMobile },
  data() {
    return { isMobile: false };
  },
  methods: {
    onScreenResize() {
      if (window.innerWidth <= 768 && !this.isMobile) {
        this.isMobile = true;
      } else if (window.innerWidth > 768 && this.isMobile) {
        this.isMobile = false;
      }
    },
  },
  beforeMount() {
    this.isMobile = window.innerWidth < 768;
  },
  mounted() {
    window.addEventListener('resize', this.onScreenResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onScreenResize);
  },
};
</script>

<style>
.btn-gradient {
  background-image: linear-gradient(
    rgba(255, 223, 34, 0.1),
    rgba(255, 223, 34, 0.2)
  );
}
</style>
